import Api from '@/utils/axios/Api';
const Http = Api.getInstance();







export const CarCreate = (payload:Object) => {
    return new Promise((resolve, reject) => {
        Http.post('car' , payload)
        .then((d) => {
            resolve(d)
        }).catch(e => {
            reject(e)
        })
    })
}

